module.exports = __webpack_public_path__ + "resources/img/img_gamebase_game1.ad9587f8c1091fbca97e1fd00c17a20a.jpg";